__turbopack_context__.v({
  "bannerTitle": "page-module__OSLHOG__bannerTitle",
  "breadcrumbActive": "page-module__OSLHOG__breadcrumbActive",
  "breadcrumbLink": "page-module__OSLHOG__breadcrumbLink",
  "breadcrumbSeparator": "page-module__OSLHOG__breadcrumbSeparator",
  "breadcrumbs": "page-module__OSLHOG__breadcrumbs",
  "btnReset": "page-module__OSLHOG__btnReset",
  "btnSubmit": "page-module__OSLHOG__btnSubmit",
  "cardIcon": "page-module__OSLHOG__cardIcon",
  "cardLabel": "page-module__OSLHOG__cardLabel",
  "cardText": "page-module__OSLHOG__cardText",
  "contactForm": "page-module__OSLHOG__contactForm",
  "contactLink": "page-module__OSLHOG__contactLink",
  "contactWrapper": "page-module__OSLHOG__contactWrapper",
  "formCard": "page-module__OSLHOG__formCard",
  "formColumn": "page-module__OSLHOG__formColumn",
  "formTitle": "page-module__OSLHOG__formTitle",
  "gridDesc": "page-module__OSLHOG__gridDesc",
  "gridTitle": "page-module__OSLHOG__gridTitle",
  "heroBanner": "page-module__OSLHOG__heroBanner",
  "heroContainer": "page-module__OSLHOG__heroContainer",
  "infoCard": "page-module__OSLHOG__infoCard",
  "infoCardsList": "page-module__OSLHOG__infoCardsList",
  "infoColumn": "page-module__OSLHOG__infoColumn",
  "infoContent": "page-module__OSLHOG__infoContent",
  "infoIconBox": "page-module__OSLHOG__infoIconBox",
  "inputGroup": "page-module__OSLHOG__inputGroup",
  "inputLabel": "page-module__OSLHOG__inputLabel",
  "mapCard": "page-module__OSLHOG__mapCard",
  "mapSection": "page-module__OSLHOG__mapSection",
  "mapSectionTitle": "page-module__OSLHOG__mapSectionTitle",
  "mapWrapper": "page-module__OSLHOG__mapWrapper",
  "pageContentWrapper": "page-module__OSLHOG__pageContentWrapper",
  "pageGrid": "page-module__OSLHOG__pageGrid",
  "socialCard": "page-module__OSLHOG__socialCard",
  "socialsGrid": "page-module__OSLHOG__socialsGrid",
  "socialsTitle": "page-module__OSLHOG__socialsTitle",
  "socialsWrapper": "page-module__OSLHOG__socialsWrapper",
  "successIcon": "page-module__OSLHOG__successIcon",
  "successText": "page-module__OSLHOG__successText",
  "successTitle": "page-module__OSLHOG__successTitle",
  "successWrapper": "page-module__OSLHOG__successWrapper",
  "textInput": "page-module__OSLHOG__textInput",
  "textareaInput": "page-module__OSLHOG__textareaInput",
  "topNavArea": "page-module__OSLHOG__topNavArea",
  "whatsappBtn": "page-module__OSLHOG__whatsappBtn",
  "whatsappWrapper": "page-module__OSLHOG__whatsappWrapper",
});
